// Single, modern key name for the whole session payload
export const PCDL_SESSION_KEY = 'pcdl.store';

const safeParse = (v) => { try { return JSON.parse(v); } catch { return null; } };

export const storage = {
  getSession() { return safeParse(localStorage.getItem(PCDL_SESSION_KEY)); },
  setSession(payload) { localStorage.setItem(PCDL_SESSION_KEY, JSON.stringify(payload)); },
  clearSession() { localStorage.removeItem(PCDL_SESSION_KEY); },
};
